import React, { useContext } from 'react'
import ambunetLogo from '../../assets/images/ambunetLogo.png'
import {
  AppBar,
  Box,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { TenantSettingsContext } from '../../App'

const Copyright = (props) => (
  <Stack>
    <Link
      href="https://ambunet.co.uk/"
      target="_blank"
      sx={{ textDecoration: 'none', color: '#3D4E50' }}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <Box component="img" src={ambunetLogo} width="5rem" />
        <Stack justifyContent="center">
          <Typography
            fontFamily="moonlander"
            textAlign="center"
            sx={{ textDecoration: 'none' }}
          >
            AmbuNet
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            textAlign="center"
            {...props}
          >
            {'Copyright © '}
            AmbuNet &#174; {new Date().getFullYear()}
            {'.'}
          </Typography>
        </Stack>
      </Stack>
    </Link>
  </Stack>
)

const CorporateSplitPage = (props) => {
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  const theme = useTheme()
  return (
    <Stack gap={1}>
      <AppBar position="static">
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          justifyContent="space-between"
          padding={1}
          bgcolor="white"
        >
          <Box component="img" src={orgSettings?.logo} maxHeight={50} />
          <Typography variant="title2">{props?.pageTitle ?? ''}</Typography>
          <Typography variant="title3">{orgSettings?.orgName}</Typography>
        </Stack>
      </AppBar>
      <Box
        component={Paper}
        padding={2}
        margin={2}
        border="solid 2px"
        borderColor={theme.palette.anBlue.main}
      >
        {props.children}
      </Box>
    </Stack>
  )
}

export default CorporateSplitPage
